"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _Scroll = _interopRequireDefault(require("../Scroll"));
var _excluded = ["children", "loadMore", "hasMore", "isReverse", "threshold", "useWindow", "parentElement"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InfiniteScroll/index.js",
  _this = void 0;
var defaultProps = {
  element: 'div',
  parentElement: null,
  // the default is the parent element of the current element
  loadMore: null,
  hasMore: true,
  isReverse: false,
  useWindow: false,
  threshold: 50
};
var InfiniteScroll = function InfiniteScroll(_ref) {
  var children = _ref.children,
    loadMore = _ref.loadMore,
    hasMore = _ref.hasMore,
    _ref$isReverse = _ref.isReverse,
    isReverse = _ref$isReverse === void 0 ? false : _ref$isReverse,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 50 : _ref$threshold,
    useWindow = _ref.useWindow,
    parentElement = _ref.parentElement,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var scrollComponentRef = _react["default"].useRef(null);
  var calculateOffset = _react["default"].useCallback(function (element, scrollTop) {
    if (useWindow) {
      var windowHeight = window.innerHeight;
      var scrollHeight = document.documentElement.scrollHeight;
      var offset = scrollHeight - scrollTop - windowHeight;
      return offset;
    } else {
      var parent = parentElement || element.parentNode;
      var _scrollHeight = parent.scrollHeight;
      var elementHeight = parent.clientHeight;
      var _offset = _scrollHeight - scrollTop - elementHeight;
      return _offset;
    }
  }, []);
  var getRef = _react["default"].useCallback(function (node) {
    scrollComponentRef.current = node;
  }, []);
  var onScroll = _react["default"].useCallback(function (scrollTop) {
    if (!hasMore) {
      return;
    }
    var element = scrollComponentRef.current;
    var offset = isReverse ? scrollTop : calculateOffset(element, scrollTop);
    if (offset < Number(threshold) && typeof loadMore === "function") {
      loadMore();
    }
  }, [hasMore, isReverse, threshold, loadMore]);
  return /*#__PURE__*/_react["default"].createElement(_Scroll["default"], Object.assign({
    parentElement: parentElement,
    useWindow: useWindow
  }, props, {
    onScroll: onScroll,
    getRef: getRef,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 9
    }
  }), children);
};
InfiniteScroll.defaultProps = defaultProps;
var _default = exports["default"] = InfiniteScroll;